/**
 * AlmadarPostIkeaEffectSoftwareSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostIkeaEffectSoftwareSLPostPage
 */

import { useAlmadarPostIkeaEffectSoftwareSLPostPageLogic } from '@/hooks/traits/useAlmadarPostIkeaEffectSoftwareSLPostPageLogic';
import type { AlmadarPostIkeaEffectSoftwareSLPostPageConfig } from '@/hooks/traits/useAlmadarPostIkeaEffectSoftwareSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostIkeaEffectSoftwareSLPostView as AlmadarPostIkeaEffectSoftwareSLPostViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { AlmadarPostIkeaEffectSoftwareSLPostHeaderView } from '@/components/traits/AlmadarPostIkeaEffectSoftwareSLPostHeaderView';
import { Container } from '@almadar/ui/components';
import { AlmadarPostIkeaEffectSoftwareSLPostView } from '@/components/traits/AlmadarPostIkeaEffectSoftwareSLPostView';
import { AlmadarPostIkeaEffectSoftwareSLPostFooterView } from '@/components/traits/AlmadarPostIkeaEffectSoftwareSLPostFooterView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostIkeaEffectSoftwareSLPostPageViewProps {
  config?: Partial<AlmadarPostIkeaEffectSoftwareSLPostPageConfig>;
}

export function AlmadarPostIkeaEffectSoftwareSLPostPageView({ config: propsConfig }: AlmadarPostIkeaEffectSoftwareSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostIkeaEffectSoftwareSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostIkeaEffectSoftwareSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostIkeaEffectSoftwareSL" trait="AlmadarPostIkeaEffectSoftwareSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostIkeaEffectSoftwareSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><AlmadarPostIkeaEffectSoftwareSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" paddingY="xl" fullWidth={true}><Container maxWidth="xl" size="xl" padding="lg"><AlmadarPostIkeaEffectSoftwareSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostIkeaEffectSoftwareSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostIkeaEffectSoftwareSLPostPageView;
